// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __extends } from "tslib";
import { InternalInAppMessagingClass } from '../internals/InternalInAppMessaging';
var InAppMessaging = /** @class */ (function (_super) {
    __extends(InAppMessaging, _super);
    function InAppMessaging() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Get the map resources that are currently available through the provider
         * @param {string} provider
         * @returns - Array of available map resources
         */
        _this.syncMessages = function () { return _super.prototype.syncMessages.call(_this); };
        _this.identifyUser = function (userId, userInfo) {
            return _super.prototype.identifyUser.call(_this, userId, userInfo);
        };
        return _this;
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */
    InAppMessaging.prototype.getModuleName = function () {
        return 'InAppMessaging';
    };
    return InAppMessaging;
}(InternalInAppMessagingClass));
export default InAppMessaging;
//# sourceMappingURL=InAppMessaging.js.map